import classNames from 'classnames';
import styles from './AcademyDetailTag.module.scss';

export interface AcademyDetailTagProps {
	className?: string;
	academyType?: Models.AcademyType['name'];
	children?: React.ReactNode;
}

export const AcademyDetailTag: React.FC<AcademyDetailTagProps> = ({ className, academyType, children }) => {
	return (
		<div className={classNames(styles.AcademyDetailTag, { [styles[`AcademyDetailTag___${academyType}`]]: academyType }, className)}>
			<span className={styles.AcademyDetailTag_tagName}>{children || academyType}</span>
		</div>
	);
};
